import ScrollableContainer from '../../../util/ScrollableContainer'
import SortableListContainer from '../../../components/SortableListContainer'
import DropdownTemplateView from '../../../DropdownTemplateView'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import ColumnRow from './ColumnRow'
import {getColumnsForConfigMenu} from './selectors'
import {changeColumnOrder, changeColumnSelection, saveChanges} from './actions'
import {isArraysWithIdsItemsOrderEqual} from "../../../atUtils";


class ColumnConfiguratorMenu extends DropdownTemplateView {
    constructor({
        onPositionChanged = () => {},
        onColumnsStatusChanged = () => {},
        onApply = () => {},
        onShow = () => {},
        onHide = () => {},
    }) {
        super()

        this.nodes = {}

        this.state = {
            $showAt: null,
            params: {},

            columns: [],
            shown: false,
        }

        this.callbacks = {
            onPositionChanged,
            onColumnsStatusChanged,
            onApply,
            onHide,
            onShow,
        }

        this.onStatePropertyChanged('columns', (columns, prevStateColumns) => {
            if (!isArraysWithIdsItemsOrderEqual(columns, prevStateColumns || [])) {
                this._updateStateOfList()
            } else {
                this._updateStateOfRows(columns)
            }
        })
    }


    templateHtml() {
        return '<div class="columnsConfiguratorMenu">' +
               '  <div class="title"><%-title%></div>' +
               '  <div class="columnsContainer"></div>' +
               '  <div class="buttons">' +
               '    <div class="applyButton"><%-apply%></div>' +
               '    <div class="cancelButton"><%-cancel%></div>' +
               '  </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'task.list.column_configurator.title',
            apply: 'common.apply',
            cancel: 'common.cancel',
        }
    }

    afterRender() {
        const columnRowRenderer = (item) => {
            const node = new ColumnRow({
                id: item.id,
                name: item.name,
                selected: item.selected,
                position: item.position,
                onColumnSelected: this.callbacks.onColumnsStatusChanged,
            })

            this.nodes[item.id] = node
            return node
        }

        this.sortableStatusesListContainer =  new SortableListContainer({
            itemRenderer: columnRowRenderer,
            sortableConfig: {
                axis: 'y',
                containmentEl: this.find('.columnsContainer')
            },
            onPositionChangedCb: ({id, itemIndex}) => {
                this.callbacks.onPositionChanged(id, itemIndex)
            }
        })
        this.sortableStatusesList = new ScrollableContainer(null, this.sortableStatusesListContainer).init(this.find('.columnsContainer'))

        this.find('.applyButton').click(() => {
            this.callbacks.onApply()
            this.hide()
        })

        this.find('.cancelButton').click(() => {
            this.hide()
        })
    }

    onHide() {
        this.sortableStatusesListContainer.cancelDrag()
        super.onHide()
        this.callbacks.onHide()
    }

    _updateStateOfRows(columns) {
        columns.forEach(column => {
            this.nodes[column.id].setState({
                selected: column.selected,
            })
        })
    }

    _updateStateOfList() {
            this.sortableStatusesList.setState({
                items: this.state.columns,
            })
    }

    openMenu() {
        this.callbacks.onShow()
        this.showAt(this.state.$showAt, this.state.params)
    }
}

export default connect(
    state => ({
        columns: getColumnsForConfigMenu(state),
    }),
    dispatch => ({
        onPositionChanged: bindActionCreators(changeColumnOrder, dispatch),
        onColumnsStatusChanged: bindActionCreators(changeColumnSelection, dispatch),
        onApply: bindActionCreators(saveChanges, dispatch),
    })
)(ColumnConfiguratorMenu)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/ColumnConfiguratorMenu.js